import { wsPostLogoutTraza } from "global/context/action/auth/loginTraza";
import { logoutApp } from "global/context/action/auth/logoutApp";
import { isNativeMobile } from "global/utils/platformDetector";
import {
  shouldRedirectFromAutocheckin,
  shouldRedirectFromBuscadorTurnos,
  getRouteForHashLogin,
} from "_+_Portal/utils/routingStrategy";
import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import ToasterV2 from "../global/component/Genericos/Toaster/ToasterV2";
import {
  logoutAuth,
  setUsuarioAuth,
  wsGetAuthToken,
} from "../global/context/action/auth/login";
import { guardarJsonConfig } from "../global/context/action/config/config";
import { showToaster } from "../global/context/action/toaster/toaster";
import { wsGetVersionPublicadaPortalWeb } from "../global/context/action/versionPublicada/versionPublicada";
import { GlobalContext } from "../global/context/Provider";
import { resetDropdown } from "./context/Actions/DropDownFamiliares/selectFamiliares";
import { resetEstudioGrupo } from "./context/Actions/estudioGrupo/estudioGrupo";
import { grupoFamiliarReset } from "./context/Actions/grupoFamiliar/grupoFamiliar";
import {
  resetLaboGrupo,
  wsGetLaboCentros,
} from "./context/Actions/laboGrupo/laboGrupo";
import {
  getListaFamiliares,
  resetListaFamiliares,
} from "./context/Actions/listaFamiliares/listasFamiliares";
import { localidadReset } from "./context/Actions/localidad/localidad";
import { misInformesReset } from "./context/Actions/misInformes/misInformes";
import { misLaboratoriosReset } from "./context/Actions/misLaboratorios/misLaboratorios";
import {
  misMedicosReset,
  misMedicosResetEncuesta,
} from "./context/Actions/misMedicos/misMedicos";
import { hideModal, showModal } from "./context/Actions/modal/modal";
import { resetMultitab } from "./context/Actions/multiTab/multiTab";
import { logoutPaciente, wsGetImagenPerfil } from "./context/Actions/paciente/paciente";
import { wsGetTextos } from "./context/Actions/textos/textos";
import {
  loginTokenReset,
  wsGetToken,
} from "./context/Actions/token/loginToken";
import { tokenLogout } from "./context/Actions/token/logoutToken";
import { wsGetLaboTurnos } from "./context/Actions/turnos/laboTurnos";
import { recetasDigitalesReset } from "./context/Actions/turnos/recetaDigital";
import { resetTurnosPaciente } from "./context/Actions/turnos/turnosPaciente";
import { dispositivoPacienteReset } from "./context/Actions/dispositivoPaciente/dispositivoPaciente";
import { PortalContext } from "./context/Provider";
import { hashReset, wsPostHash } from "./context/Actions/hash/hashLogin";
import GetHash from "global/utils/getHash";
import fechaTurnoFormat from "../global/utils/fechaTurnoFormat";
import GetToken from "../global/utils/getToken";
import Modal from "./components/Genericos/Modal/Modal";
import SegundoModal from "./components/Genericos/SegundoModal/SegundoModal";
import WhatsAppFloatingButton from "./components/Genericos/WhatsAppFloatingButton/WhatsAppFloatingButton";

const GlobalInitializeData = ({ children }) => {
  let path = window.location.pathname;

  const {
    textosDispatch,
    listaFamiliaresDispatch,
    textosState,
    listaFamiliaresState,
    tokenState,
    tokenDispatch,
    laboGrupoDispatch,
    laboTurnosDispatch,
    misMedicosState,
    misMedicosDispatch,
    modalState,
    segundoModalState,
    modalDispatch,
    pacienteDispatch,
    misInformesDispatch,
    misLaboratoriosDispatch,
    turnosPacienteDispatch,
    grupoFamiliarDispatch,
    localidadDispatch,
    multiTabDispatch,
    estudioGrupoDispatch,
    recetasDigitalesDispatch,
    selectDropDownDispatch,
    dispositivoPacienteDispatch,
    hashDispatch,
    hashState,
  } = useContext(PortalContext);

  const history = useHistory();
  const location = useLocation();

  // Cambio de contexto
  const {
    authState,
    configDispatch,
    configState,
    authDispatch,
    toasterDispatch,
    toasterState,
    versionPublicadaDispatch,
    versionPublicadaState,
  } = useContext(GlobalContext);

  // Redirigir entre autocheckin y buscadorTurnos según el tamaño de pantalla
  // Usa la estrategia centralizada de routing
  useEffect(() => {
    // Verificar redirección al montar/cambiar de ruta (INMEDIATO)
    let redirectRoute = null;

    // Desktop → BuscadorTurnos (si está en autocheckin)
    redirectRoute = shouldRedirectFromAutocheckin(
      location.pathname,
      configState.config.data,
    );

    // Mobile → Autocheckin (si está en buscadorTurnos)
    if (!redirectRoute) {
      redirectRoute = shouldRedirectFromBuscadorTurnos(
        location.pathname,
        configState.config.data,
      );
    }

    if (redirectRoute) {
      history.replace(redirectRoute);
      return;
    }

    // Manejar resize dinámico con debounce reducido
    let resizeTimer;
    let lastWidth = window.innerWidth;

    const handleResize = () => {
      const currentWidth = window.innerWidth;

      // Detectar cambio de breakpoint (cruzar el umbral)
      const crossedBreakpoint =
        (lastWidth < 1366 && currentWidth >= 1366) || // Mobile → Desktop
        (lastWidth >= 1366 && currentWidth < 1366); // Desktop → Mobile

      // Si cruzó el breakpoint, redirigir inmediatamente
      if (crossedBreakpoint) {
        lastWidth = currentWidth;

        let redirect = null;
        redirect = shouldRedirectFromAutocheckin(
          location.pathname,
          configState.config.data,
        );

        if (!redirect) {
          redirect = shouldRedirectFromBuscadorTurnos(
            location.pathname,
            configState.config.data,
          );
        }

        if (redirect) {
          history.replace(redirect);
          return;
        }
      }

      // Para otros cambios de tamaño, usar debounce corto
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        lastWidth = currentWidth;

        let redirect = null;
        redirect = shouldRedirectFromAutocheckin(
          location.pathname,
          configState.config.data,
        );

        if (!redirect) {
          redirect = shouldRedirectFromBuscadorTurnos(
            location.pathname,
            configState.config.data,
          );
        }

        if (redirect) {
          history.replace(redirect);
        }
      }, 50); // Reducido de 250ms a 50ms
    };

    // Solo agregar listener si estamos en una de las rutas relevantes
    if (
      location.pathname.startsWith("/autocheckin") ||
      location.pathname.startsWith("/buscadorTurnos")
    ) {
      window.addEventListener("resize", handleResize);
    }

    return () => {
      clearTimeout(resizeTimer);
      window.removeEventListener("resize", handleResize);
    };
  }, [location.pathname, history, configState.config.data]);

  // Use effect de textos
  useEffect(() => {
    if (
      authState.auth.data !== null &&
      authState.auth.data !== "" &&
      !listaFamiliaresState.listaFamiliares.data
    ) {
      getListaFamiliares(false)(listaFamiliaresDispatch);
    }
  }, [authState.auth.data]);

  // Cargar imagen de perfil si el usuario está autenticado pero no tiene imagen en el estado.
  // Se usa undefined como "todavía no se buscó" y null como "se buscó pero no tiene foto",
  // para evitar llamadas repetidas cuando el paciente no cargó una foto.
  useEffect(() => {
    const paciente = authState.auth.data?.paciente;
    if (paciente && paciente.imagenPerfil === undefined) {
      wsGetImagenPerfil("", (isCorrect, data) => {
        if (isCorrect) {
          setUsuarioAuth({
            ...authState.auth.data,
            paciente: { ...paciente, imagenPerfil: data || null },
          })(authDispatch);
        }
      })(pacienteDispatch);
    }
  }, [authState.auth.data]);

  // Use Effect de textos para evitar que se ejecute muchas veces
  useEffect(() => {
    if (!textosState.textos.data) {
      wsGetTextos()(textosDispatch);
    }
  }, []);

  useEffect(() => {
    fetch(`./config.json?v=${new Date().getTime()}`)
      .then((response) => {
        return response.json();
      })
      .then((jsondata) => {
        guardarJsonConfig(jsondata)(configDispatch);
      });
  }, []);

  //logica de token para notificacion push
  const search = useLocation().search;
  const currentURL = window.location.href;
  const urlSearchParams = new URLSearchParams(currentURL);

  const [flgPush, setFlgPush] = useState(false);
  const [urlPush, setUrlPush] = useState("");
  const [flgHash, setFlgHash] = useState(false);
  const [flgLaboTurnos, setFlgLaboTurnos] = useState(false);

  useEffect(() => {
    if (authState.auth.data !== null) {
      if (flgLaboTurnos) {
        if (
          tokenState.token.data.idProtocolo === "-1" &&
          textosState.textos.data
        ) {
          showToaster(
            {
              texto: textosState.textos.data.msjTokenProtMenosUno.descripcion,
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
          salirPortal();
        } else {
          const fecha = fechaTurnoFormat();
          const idGrupoTurnoLaboGeneral = 5;
          wsGetLaboCentros()(laboGrupoDispatch);
          wsGetLaboTurnos(
            fecha,
            -1,
            -1,
            idGrupoTurnoLaboGeneral,
          )(laboTurnosDispatch);
        }
        setFlgLaboTurnos(false);
      }
    }
  }, [authState.auth.data]);

  //-- logica ingreso por hash
  useEffect(() => {
    let hash = GetHash(search);
    if (hash !== null && hash !== undefined) {
      let dtoHash = {
        hash: hash,
      };
      wsPostHash(dtoHash, ingresarPortalHash)(hashDispatch);
    }
  }, []);

  const ingresarPortalHash = (resp, data) => {
    if (resp) {
      setFlgHash(true);
    } else {
      showToaster(
        {
          texto: data !== "" ? data.detail : data,
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    if (
      hashState.hash.data !== null &&
      hashState.hash.data !== undefined &&
      flgHash
    ) {
      const accionValue = urlSearchParams.get("accion");
      const familiarDNI = urlSearchParams.get("familiar");

      // Guardar parámetros en sessionStorage para uso posterior
      sessionStorage.setItem("accionHash", accionValue);
      if (familiarDNI) {
        sessionStorage.setItem("familiarHash", familiarDNI);
      }

      // Autenticar usuario
      setUsuarioAuth(hashState.hash.data)(authDispatch);
      setFlgHash(false);
      hashReset()(hashDispatch);

      // Determinar ruta usando estrategia centralizada
      const redirectRoute = getRouteForHashLogin(
        configState.config.data,
        accionValue,
      );
      setUrlPush(redirectRoute);
      setFlgPush(true);
    }
  }, [hashState.hash.data, flgHash, configState.config.data]);
  //-- fin ingreso por hash

  useEffect(() => {
    let token = GetToken(search);
    if (token !== null && token !== undefined) {
      wsGetToken(token, nextStepTokenURL)(tokenDispatch);
    }
  }, []);

  const idPaciente = localStorage.getItem("idPaciente");
  const handleEncuesta = (token, data) => {
    if (!isNativeMobile() || !idPaciente) {
      wsGetAuthToken(token, () => {
        modalCalificacion(data.encuesta);
      })(authDispatch);
    } else {
      modalCalificacion(data.encuesta);
    }
  };

  const handleGetAuth = (token) => {
    if (!isNativeMobile() || !idPaciente) {
      wsGetAuthToken(token)(authDispatch);
    }
  };

  const nextStepTokenURL = (isCorrect, data, token) => {
    if (isCorrect) {
      if (data !== null) {
        if (data.codigo !== null) {
          switch (data.codigo) {
            case 1: // Activar cuenta
              handleGetAuth(token);
              history.push("/auth/activacion");
              break;
            case 5: // Mercado Pago
            case 6: // Subir orden de Turno
            case 7: // Subir orden de Labo
            case 10: // Ingresar a Prox Turnos para confirmar
            case 11: // Cancelar turno
            case 14: // Cancelar turno labo
            case 15: // Mercado Pago labo
            case 21: //Ingresar a Prox Turnos para ver turno
              handleGetAuth(token);
              setUrlPush("/proximosTurnos");
              setFlgPush(true);
              break;
            case 12:
            case 16: // Responder encuesta turno, responder encuesta labo
              handleEncuesta(token, data);
              break;
            case 13: // Ingresar a Familiares
              handleGetAuth(token);
              setUrlPush("/GrupoFamiliar");
              setFlgPush(true);
              break;
            case 17: // Orden digital labo sin turno
              handleGetAuth(token);
              setFlgLaboTurnos(true);
              break;
            case 19: // Ingresar a Resultados informes
              handleGetAuth(token);
              setUrlPush("/misInformes");
              setFlgPush(true);
              break;
            case 20: // Ingresar a Resultados Labo
              handleGetAuth(token);
              setUrlPush("/misLaboratorios");
              setFlgPush(true);
              break;
            case 22: // Ingresar a Prox Turnos para ver la orden controlada
              handleGetAuth(token);
              setUrlPush("/proximosTurnos");
              setFlgPush(true);
              break;
            case 23: // QR de informe: modal dedicado que pide la clave de 4 chars para ver la imagen.
              // Con el token (de la URL del QR) + la clave, el backend valida (vigencia + clave)
              // y devuelve la URL del visor, que se abre en una pestaña nueva.
              showModal(
                "Genericos/VerImagenEstudioQr/VerImagenEstudioQr",
                {
                  token: token,
                  emailMasked: data.emailMasked,
                  dissmiss: () => hideModal()(modalDispatch),
                },
                null,
                "centro",
                false,
              )(modalDispatch);
              break;
            default:
              if (path !== "/") history.push("/");
              break;
          }
        }
        const excludedCodes = [1, 5, 6, 7, 10, 11, 12, 14, 15, 16, 17, 19, 20];
        if (!excludedCodes.includes(data.codigo)) {
          loginTokenReset()(tokenDispatch);
        }
      }
    }
  };

  useEffect(() => {
    if (flgPush === true && authState.auth.data) {
      history.push(urlPush);
      setFlgPush(false);
      setUrlPush("");
    }
  }, [authState.auth.data, flgPush]);

  useEffect(() => {
    if (
      tokenState.token.error !== false &&
      tokenState.token.error !== null &&
      tokenState.token.error !== undefined
    ) {
      if (path !== "/") history.push("/");
      //este timeout sirve para realizar las acciones en caso de error, sin él no llega a escuchar los cambios.
      setTimeout(() => {
        logoutAuth()(authDispatch);
        tokenLogout(history)(tokenDispatch);

        const error = tokenState.token.error;

        // Determinar mensaje a mostrar con fallback robusto
        let mensajeError;

        if (
          error.type === "VALIDATION_ERROR" &&
          error.validationErrors?.length > 0
        ) {
          mensajeError = error.validationErrors[0].message;
        } else {
          // Siempre tendrá detail como string gracias a parseBackendError
          // Con fallback adicional por si acaso
          mensajeError =
            typeof error.detail === "string"
              ? error.detail
              : error.detail?.detail || "El enlace es inválido o ha expirado";
        }

        showToaster(
          {
            texto: mensajeError,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }, 1000);
    }
    //eslint-disable-next-line
  }, [tokenState.token.error]);

  //Este modal se abre con token en url
  const modalCalificacion = (encuesta) => {
    if (encuesta[0] !== null && encuesta[0] !== undefined) {
      showModal(
        "Genericos/CalificarMisMedicos/CalificarMisMedicos",
        {
          titulo: "¿Cómo fue su experiencia en su atención médica?",
          item: {
            recepcionista: encuesta[0].nombre_recepcionista,
            medico: encuesta[0].nombre_medico,
            tecnico: encuesta[0].nombre_tecnico,
            idTurno: encuesta[0].idturno,
            encuesta: null,
            idProtocolo: encuesta[0].idprotocolo,
          },
          estrellas_medico_actual:
            encuesta[0].estrellas_medico !== null
              ? encuesta[0].estrellas_medico
              : 0,
          estrellas_recepcion_actual:
            encuesta[0].estrellas_recepcion !== null
              ? encuesta[0].estrellas_recepcion
              : 0,
          estrellas_tecnico_actual:
            encuesta[0].estrellas_tecnico !== null
              ? encuesta[0].estrellas_tecnico
              : 0,
          detalle_recepcion_actual:
            encuesta[0].detalles_recepcion !== null
              ? encuesta[0].detalles_recepcion
              : "",
          detalle_medico_actual:
            encuesta[0].detalles_medico !== null
              ? encuesta[0].detalles_medico
              : "",
          detalles_tecnico_actual:
            encuesta[0].detalles_tecnico !== null
              ? encuesta[0].detalles_tecnico
              : "",
          flgEncuestaToken: true,
          dissmiss: dissmiss,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    } else {
      showToaster(
        {
          texto: "La encuesta ya fue respondida",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  //toaster de encuesta realizada + limpiar state
  useEffect(() => {
    if (misMedicosState.misMedicos.altaEncuesta !== null) {
      if (misMedicosState.misMedicos.altaEncuesta.origen === "calificaOk") {
        showToaster(
          {
            texto: "Encuesta realizada correctamente",
            tipo: "success",
          },
          "centroArriba",
        )(toasterDispatch);
        misMedicosResetEncuesta()(misMedicosDispatch);
      }
    }
  }, [misMedicosState.misMedicos.altaEncuesta]);

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  //chequeo version portal web
  useEffect(() => {
    if (
      versionPublicadaState.versionPublicada.data === null &&
      configState.config.data !== null
    ) {
      wsGetVersionPublicadaPortalWeb(configState.config.data.sectorVersion)(
        versionPublicadaDispatch,
      );
    }
  }, [versionPublicadaState.versionPublicada.data, configState.config.data]);

  const dismissVersion = () => {
    if (!versionPublicadaState.versionPublicada.data.critico) {
      hideModal()(modalDispatch);
    } else {
      showToaster(
        {
          texto: "Debe actualizar la aplicación para continuar",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  // Lógica de versionado: primero verificar mantenimiento, luego diferencia de versión
  useEffect(() => {
    // Verificar que los datos necesarios estén disponibles
    if (
      !versionPublicadaState.versionPublicada.data ||
      !configState.config.data
    ) {
      return;
    }

    const isNative = isNativeMobile();
    const { mantenimiento, version: versionPublicada } =
      versionPublicadaState.versionPublicada.data;
    const { version: versionLocal } = configState.config.data;

    // 1. Prioridad: Mantenimiento (se muestra en todas las plataformas)
    if (mantenimiento) {
      showModal(
        "Genericos/VersionMantenimiento/VersionMantenimiento",
        {},
        [],
        "centro",
        true,
      )(modalDispatch);
      return;
    }

    // 2. Verificar diferencia de versión
    const hayDiferenciaVersion = versionLocal !== versionPublicada;

    if (hayDiferenciaVersion) {
      if (isNative) {
        // Modal para app nativa (Android/iOS)
        showModal(
          "Genericos/VersionApp/VersionApp",
          {
            dissmiss: dismissVersion,
          },
          [],
          "centro",
          true,
        )(modalDispatch);
      } else {
        // Modal para portal web
        showModal(
          "Genericos/VersionPortalWeb/VersionPortalWeb",
          {
            dissmiss: dismissVersion,
          },
          [],
          "centro",
          true,
        )(modalDispatch);
      }
    }
  }, [versionPublicadaState.versionPublicada.data, configState.config.data]);
  //-- fin logica versionado

  //Portal en Mantenimiento
  //--mantenimiento preventivo(por urgencia) si estas logueado te invita a salir
  const salirPortal = () => {
    if (authState.authTraza.data !== null) {
      wsPostLogoutTraza(authState.authTraza.data.id, {
        ingreso: false,
        sector: configState.config.data.sectorTurno,
      })(authDispatch);
    }
    logoutApp(history)(authDispatch);
    logoutPaciente(history)(pacienteDispatch);
    tokenLogout(history)(tokenDispatch);
    misMedicosReset()(misMedicosDispatch);
    misInformesReset()(misInformesDispatch);
    misLaboratoriosReset()(misLaboratoriosDispatch);
    resetTurnosPaciente()(turnosPacienteDispatch);
    grupoFamiliarReset()(grupoFamiliarDispatch);
    localidadReset()(localidadDispatch);
    resetMultitab()(multiTabDispatch);
    resetLaboGrupo()(laboGrupoDispatch);
    resetEstudioGrupo()(estudioGrupoDispatch);
    resetListaFamiliares()(listaFamiliaresDispatch);
    recetasDigitalesReset()(recetasDigitalesDispatch);
    resetDropdown()(selectDropDownDispatch);
    dispositivoPacienteReset()(dispositivoPacienteDispatch); // ✅ Reset del estado de dispositivo
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("idApp");
    localStorage.removeItem("idPaciente");
    sessionStorage.token = "";
    sessionStorage.auth = "";
    hideModal()(modalDispatch);
  };

  useEffect(() => {
    if (configState.config.data) {
      if (configState.config.data.mantenimiento && authState.auth.data) {
        showModal(
          "Genericos/AvisoMantenimiento/AvisoMantenimiento",
          {},
          [
            {
              text: "Salir del Portal",
              clase: "btn bgc-primary rb16m c-white",
              // clase: "btn b-latex30 rb16m c-latex30",
              accion: salirPortal,
            },
          ],
          "centro",
          true,
        )(modalDispatch);
      }
    }
  }, [configState.config.data]);
  //-- fin portal mantenmiento urgencia

  /*   // Manejo del botón de retroceso en Android para no minimizar la app
  useEffect(() => {
    if (!isNativeMobile()) return;
    const backHandler = CapacitorApp.addListener("backButton", () => {
      if (ionRouter.canGoBack()) {
        if (history.location.pathname === "/autocheckin") {
          ionRouter.push("/autocheckin");
        } else {
          ionRouter.goBack();
        }
      } else {
        const now = Date.now();

        if (lastBackPress.current && now - lastBackPress.current < 2000) {
          CapacitorApp.exitApp(); // Salir de la app
        } else {
          lastBackPress.current = now;
        }
      }
    });

    return () => {
      backHandler.remove();
    };
  }, [ionRouter]); */

  return (
    <>
      {toasterState.toaster.show && <ToasterV2 />}
      {modalState.modal.show && <Modal />}
      {segundoModalState.segundoModal.show && <SegundoModal />}
      <WhatsAppFloatingButton />
      <div>{children}</div>
    </>
  );
};

export default GlobalInitializeData;
